<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-select :items="equipmentType" label="Equipment" v-model="equipmentFilter"></v-select>
                  <v-radio-group v-model="selectedCategory" row>
                    <v-radio label="Today" value="Today"></v-radio>
                    <v-radio label="This Week" value="This Week"></v-radio>
                    <v-radio label="All" allCheckbox value="All"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model="originFilter.city" type="text" label="Origin City"></v-text-field>
                  <v-text-field v-model="destinationFilter.city" type="text" label="Destination City"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field v-model="originFilter.state" type="text" label="Origin State"></v-text-field>

                  <v-spacer></v-spacer>
                  <v-text-field v-model="destinationFilter.state" type="text" label="Destination State"></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn small @click="resetSearch()">Reset Search</v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-data-table :loading="loading" loading-text="Loading... Please wait" :headers="headers" :items="loadsFiltered"
            item-key="reference_id" calculate-widths>
            <template v-slot:item.reference_id="{ item }">
              <v-btn text target="_blank" :href="magicLink(item.reference_id)">{{ item.reference_id }}</v-btn>
            </template>
            <template v-slot:item.origin="{ item }">
              <p>
                <span class="font-weight-bold">{{ item.origin.city }}, {{ item.origin.state }}</span>
                <br />
                <span class="subtitle">{{
                  item.origin.src_date_formatted
                }}</span>
              </p>
            </template>
            <template v-slot:item.destination="{ item }">
              <p>
                <span class="font-weight-bold">{{ item.destination.city }},
                  {{ item.destination.state }}</span>
                <br />
                <span class="subtitle">{{
                  item.destination.dst_date_formatted
                }}</span>
              </p>
            </template>
            <template v-slot:item.details="{ item }">
              <p>
                <span class="font-weight-bold">Weight:</span>
                {{ item.details.weight }} <br />
                <span class="font-weight-bold">Commodity:</span>
                {{ item.details.commodity }} <br />
                <span class="font-weight-bold">Distance:</span>
                {{ item.details.distance }} miles
              </p>
            </template>
            <template v-slot:item.display_metadata="{ item }">
              <span v-for="(metadata, index) in item.display_metadata" v-bind:key="index" class="pt-0 pb-0">
                {{ metadata }}<br>
              </span>
            </template>
            <template v-slot:item.book="{ item }">
              <v-btn small color="#CB333B" :href="magicLink(item.reference_id)" target="_blank" dark>{{ item.book
              }}</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
var moment = require("moment");
export default {
  name: "MainLoadboard",
  data() {
    return {
      loading: false,
      selectedCategory: [],
      equipmentList: [],
      equipmentFilter: "",
      originFilter: {
        city: "",
        state: ""
      },
      destinationFilter: {
        city: "",
        state: ""
      },
      loads_formatted: [],
      headers: [
        { text: "Reference ID", value: "reference_id" },
        {
          text: "Equipment",
          value: "equipment",
          width: "10%",
          filter: f => {
            return (f + "")
              .toLowerCase()
              .includes(this.equipmentFilter.toLowerCase());
          }
        },
        {
          text: "Origin",
          value: "origin",
          width: "20%",
          filter: f => {
            return this.cityStateFilter(f, this.originFilter);
          }
        },
        {
          text: "Destination",
          value: "destination",
          width: "20%",
          filter: f => {
            return this.cityStateFilter(f, this.destinationFilter);
          }
        },
        { text: "Details", value: "details", filterable: false, sortable: false },
        { text: "Requirements", value: "display_metadata", filterable: false, sortable: false },
        { text: "", value: "book", filterable: false, sortable: false }
      ]
    };
  },
  computed: {
    loadsFiltered() {
      var vm = this;
      var category = vm.selectedCategory;
      const today = new Date();
      const today_formatted_date = `${today.getMonth() +
        1}-${today.getDate()}-${today
          .getFullYear()
          .toString()
          .substr(-2)}`;
      if (category.includes("All")) {
        return vm.loads_formatted;
      }
      if (category.includes("Today")) {
        return vm.loads_formatted.filter(load => {
          var matchFilter = false;
          if (load.origin.src_date_formatted === today_formatted_date) {
            matchFilter = true;
          }
          return matchFilter;
        });
      }
      if (category.includes("This Week")) {
        return vm.loads_formatted.filter(load => {
          var matchFilter = false;
          if (moment(load.origin.src_date).isSame(today, "week")) {
            matchFilter = true;
          }
          return matchFilter;
        });
      } else {
        return vm.loads_formatted;
      }
    },
    equipmentType() {
      return this.equipmentList.filter((x, i, a) => a.indexOf(x) === i);
    },
  },
  methods: {
    cityStateFilter(f, filter) {
      if (filter.city === "" && filter.state === "") {
        return f;
      }
      if (filter.city !== "" && filter.state === "") {
        return (f.city + "").toLowerCase().includes(filter.city.toLowerCase());
      }
      if (filter.city === "" && filter.state !== "") {
        return (f.state + "")
          .toLowerCase()
          .includes(filter.state.toLowerCase());
      }
      if (filter.city !== "" && filter.state !== "") {
        return (f.city + f.state + "")
          .toLowerCase()
          .includes(filter.city.toLowerCase(), filter.state.toLowerCase());
      }
    },
    resetSearch() {
      this.equipmentFilter = "";
      this.originFilter.city = "";
      this.originFilter.state = "";
      this.destinationFilter.city = "";
      this.destinationFilter.state = "";
      this.selectedCategory = [];
    },
    transformNullEquipment(equipment) {
      if (equipment === null) {
        return "ANY";
      } else {
        return equipment;
      }
    },
    transformDisplayMetadata(display_metadata) {
      var display_keys = []
      try {
        if (display_metadata !== null) {
          var myobj = JSON.parse(display_metadata);
          for (let [key, value] of Object.entries(myobj)) {
            if (value) {
              display_keys.push(`${key}: ${value}`)
            } else {
              display_keys.push(`${key}`)
            }
          }
          return display_keys
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },
    formatDate(date) {
      var d = new Date(date);
      const formatted_date = `${d.getUTCMonth() + 1}-${d.getUTCDate()}-${d
        .getFullYear()
        .toString()
        .substr(-2)}`;
      return formatted_date;
    },
    magicLink(reference_id) {
      return `http://load.app/jones/${reference_id}`;
    },
    getLoads() {
      this.loading = true;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(
        "https://us-central1-jones-non-auth-loadboard.cloudfunctions.net/jones_non_auth_loadboard_prod",
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          for (const element of result.result) {

            const load = {
              reference_id: element["reference_id"],
              equipment: this.transformNullEquipment(element["equipment"]),
              origin: {
                src_date: element["src_date"],
                src_date_formatted: this.formatDate(element["src_date"]),
                city: element["src_city"],
                state: element["src_state"]
              },
              destination: {
                city: element["dst_city"],
                state: element["dst_state"],
                dst_date: element["dst_date"],
                dst_date_formatted: this.formatDate(element["dst_date"])
              },
              // rate: element["rate"],
              details: {
                weight: element["weight"],
                commodity: element["commodity"],
                distance: Math.round(element["distance"])
              },
              display_metadata: this.transformDisplayMetadata(element['display_metadata']),
              book: "Book Now"
            };
            this.equipmentList.push(
              this.transformNullEquipment(element["equipment"])
            );
            this.loads_formatted.push(load);
            this.loading = false;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log("error", error);
        });
    }
  },
  created() {
    this.getLoads();
  }
};
</script>
